import React, { useEffect, useState } from 'react';

import leaveapprove from '../../assests/images/leave approve.svg';
import leavepending from '../../assests/images/leave-pending.svg';
import '../../assests/style.css';

import candidatesvg from '../../assests/images/candidate.svg';
import employeesvg from '../../assests/images/employee.svg';
import rejectedsvg from '../../assests/images/rejected.svg';
import unverifiedsvg from '../../assests/images/unverified.svg';
import verifiedsvg from '../../assests/images/verified.svg';

import { toast } from 'react-toastify';
import { Bar, BarChart, Cell, Legend, Pie, PieChart, Tooltip, XAxis, YAxis } from "recharts";
import { API_SERVER } from '../../Utils';
import { post } from '../../apiservices/service';
import { useAuth } from '../../context/auth';
import { Token } from '../Common/Common';

// Card component to handle repeated sections
const Card = ({ title, children }) => (
    <div className="main-card card border-0">
        <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
            <h6 className="mb-0 fw-bold">{title}</h6>
        </div>
        <div className="card-body">
            {children}
        </div>
    </div>
);

// DashboardRight component
const DashboardRight = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false)
    const TokenData = Token()
    const { user, sessionExpired } = useAuth();
    const [countData, setCountData] = useState({
        pendingVerification: "0",
        pendingConvertToEmployee: "0",
        totalCandidate: "0",
        convertedToEmployee: "0",
        rejectedCandidate: "0",
        leavePendingToday: "0",
        leaveApproveToday: "0",
        leavePending30Days: "0",
        leaveApprove30Days: "0",
        notUpdated: "0",
        employeeHeadCount: "0",
        maleEmployeeCount: "0",
        femaleEmployeeCount: "0",
        newemployeeHeadCount: "0",
        leftemployeeHeadCount: "0",
        totalmployeeHeadCount: "0",
        jan: "0",
        feb: "0",
        mar: "0",
        apr: "0",
        may: "0",
        jun: "0",
        jul: "0",
        aug: "0",
        sep: "0",
        oct: "0",
        nov: "0",
        dec: "0",
    });
    const [upComingBirthday, setupComingBirthday] = useState();
    const [department, setDepartment] = useState();
    const [toLate, settoLate] = useState();
    const [onTime, setonTime] = useState();

    useEffect(() => {
        GetDashboardCount();
    }, []);

    const GetDashboardCount = () => {
        setLoading(true)
        post(`${API_SERVER}api/Dashboard/GetDashboardCount`, { ...TokenData }, (res) => {
            if (res && res.status) {
                if (res.status === "ERROR") {
                    toast.error(res.message)
                    setLoading(false)
                } else if (res.Status === "EXPIRED") {
                    toast.error(res.Message)
                    sessionExpired()
                } else if (res.Status === "UNAUTHORIZED") {
                    toast.error(res.Message);
                    setLoading(false);
                } else {
                    setLoading(false)
                    let data = res.data
                    setCountData(data);
                    let upComingBirthday = res.upComingBirthday
                    setupComingBirthday(upComingBirthday);

                    let toLate = res.toLate
                    settoLate(toLate);
                    //console.log(toLate);
                    let onTime = res.onTime
                    setonTime(onTime);
                    let department = res.department
                    setDepartment(department);
                }
            }
        });
    }

    return (
        <div className="employee-dashboard-right">
            <div className="container-fluid">
                <div className="row">
                    {/* Leave Dashboard */}
                    <div className="col-lg-8 col-12">
                        <div className="row">
                            <div className="col-lg-6 col-12 mb-3">
                                <Card title="Leave Dashboard">
                                    <div className="row g-2 row-deck">
                                        {/* Leave Pending Today */}
                                        <CardItem title="Leave Pending Today" count={countData.leavePendingToday} image={leavepending} />
                                        {/* Leave Pending 30 Days */}
                                        <CardItem title="Leave Pending 30 Days" count={countData.leavePending30Days} image={leavepending} />
                                        {/* Leave Approved Today */}
                                        <CardItem title="Leave Approve Today" count={countData.leaveApproveToday} image={leaveapprove} />
                                        {/* Leave Approved 30 Days */}
                                        <CardItem title="Leave Approved 30 Days" count={countData.leaveApprove30Days} image={leaveapprove} />
                                    </div>
                                </Card>
                            </div>

                            {/* Departments */}
                            <div className="col-lg-6 col-12 mb-3">
                                <Card /*title="Departments"*/>
                                    <LateDashboard title="Late Arrival" employees={toLate} />
                                    <LateDashboard title="On Time" employees={onTime} />
                                </Card>
                            </div>

                            {/* Employee Head Count */}
                            <div className="col-lg-6 col-12 mb-3">
                                <Card title="Employee Head Count">
                                    <div className="head-count mt-2">
                                        <PieChartComponent HeadCount={countData.employeeHeadCount} male={countData.maleEmployeeCount} female={countData.femaleEmployeeCount} />
                                    </div>
                                </Card>
                            </div>

                            {/* Other Graphs */}
                            <div className="col-lg-6 col-12 mb-3">
                                <Card title="Department Wise Head Count">
                                    <div className="head-count mt-2">
                                        <DepartmentChartComponent data1={department ? department : ""} />
                                    </div>
                                </Card>
                            </div>
                            <div className="col-lg-6 col-12 mb-3">
                                <Card>
                                    <div className="head-count mt-2">
                                        {/* <img src={graph3png} alt="Graph 3" className="img-fluid" />*/}
                                        <SalesChart 
                                            Jan={countData.jan}
                                            Feb={countData.feb}
                                            Mar={countData.mar}
                                            Apr={countData.apr}
                                            May={countData.may}
                                            Jun={countData.jun}
                                            Jul={countData.jul}
                                            Aug={countData.aug}
                                            Sep={countData.sep}
                                            Oct={countData.oct}
                                            Nov={countData.nov}
                                            Dec={countData.dec}
                                        />
                                    </div>
                                </Card>
                            </div>
                            <div className="col-lg-6 col-12 mb-3">
                                <Card>
                                    <div className="head-count mt-2">
                                        <EmployeeChart TotalEmployee={countData.totalmployeeHeadCount} newJoining={countData.newemployeeHeadCount} left={countData.leftemployeeHeadCount} />
                                    </div>
                                </Card>
                            </div>

                        </div>
                    </div>

                    {/* Onboarding Dashboard */}
                    <div className="col-lg-4 col-12">
                        <Card title="Onboarding Dashboard">
                            <div className="row g-2 row-deck">
                                <OnboardingItem title="Total Candidate" count={countData.totalCandidate} image={candidatesvg} />
                                <OnboardingItem title="Converted to Employee" count={countData.convertedToEmployee} image={employeesvg} />
                                <OnboardingItem title="Rejected" count={countData.rejectedCandidate} image={rejectedsvg} />
                                <OnboardingItem title="Pending for Verification" count={countData.pendingVerification} image={unverifiedsvg} />
                                <OnboardingItem title="Pending to Convert" count={countData.pendingConvertToEmployee} image={verifiedsvg} />
                                <OnboardingItem title="Pending Candidate Response" count={countData.notUpdated} image={verifiedsvg} />
                            </div>
                        </Card>

                        {/* Upcoming Birthday */}
                        <Card title="Upcoming Birthday">
                            <div className="flex-grow-1">
                                {!upComingBirthday ? ( // Handle null state (loading)
                                    <p>Loading birthdays...</p>
                                ) : upComingBirthday.length > 0 ? ( // Handle valid data
                                    upComingBirthday.map((person, index) => (
                                        <UpcomingBirthday
                                            key={index}
                                            name={person.empName}
                                            position={person.designation}
                                            date={person.dob}
                                        />
                                    ))
                                ) : ( // Handle empty array
                                    <p>No upcoming birthdays</p>
                                )}
                                {/*<UpcomingBirthday name="Natalie Gibson" position="UI/UX Designer" date="28 Jan, 2025" />*/}
                                {/* Repeat for more birthdays */}
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>
    );
};

// CardItem component for the leave dashboard items
const CardItem = ({ title, count, image }) => (
    <div className="col-md-6 col-sm-6">
        <div className="card">
            <div className="card-body">
                <a href="../Report/LeaveStatusReport" style={{ all: 'unset' }} target="_blank">
                <div className="dashboard-card-icon">
                    <img src={image} alt={title} />
                </div>
                {/*<h6 className="mt-3 mb-0 fw-bold small-14">{title}</h6>*/}
                <h6 className="">{title}</h6>
                    <span className="text-muted">{count}</span>
                </a>
            </div>
        </div>
    </div>
);

// LateDashboard component for late arrival/on-time images
const LateDashboard = ({ title, employees }) => {
    return (
        <div className="late-dashboard my-4">
            <h6>{title}</h6>
            <a href="../Report/LateReport" target="_blank">
            <div className="avatars-container">
                {
                    employees?.slice(0, 8).map((emp, i) => (
                        //<img
                        //    key={emp.empID}
                        //    className="avatar-dashboard"
                        //    src={emp.empPhoto ? `data:image/jpeg;base64,${emp.empPhoto}` : avatar2}
                        //    alt={emp.empName}
                        //    title={emp.empName}
                        ///>
                        <label title={emp.empName} style={{ cursor: 'pointer' }} >&nbsp; {emp.empCode}&nbsp;</label>
                    ))}
                {employees?.length > 8 && <span>+{employees.length - 8} More</span>}
                </div>
            </a>
        </div>
    );
};

// OnboardingItem component for onboarding dashboard items
const OnboardingItem = ({ title, count, image }) => (
    <div className="col-md-6 col-sm-6">
        <div className="card">
            <a href="../Candidate/SearchCandidate" style={{ all: 'unset' }} target="_blank">
            <div className="card-body">
                <div className="dashboard-card-icon">
                    <img src={image} alt={title} />
                </div>
                {/* <h6 className="mt-3 mb-0 fw-bold small-14">{title}</h6>*/}
                <h6>{title}</h6>
                <span className="text-muted">{count}</span>
                </div>
            </a>
        </div>
    </div>
);

// UpcomingBirthday component to display birthday info
const UpcomingBirthday = ({ name, position, date }) => (
    <div className="py-2 d-flex align-items-center border-bottom flex-wrap">
        <div className="d-flex align-items-center flex-fill">
            {/*<img className="avatar-dashboard" src={avatar1} alt="profile" width="" />*/}
            <div className="d-flex flex-column ps-3">
                <h6 className="fw-bold mb-0 small-14">{name}</h6>
                <span className="text-muted">{position}</span>
            </div>
        </div>
        <div className="dashboard-birthday-date">
            <i className="fa-solid fa-calendar-days">
                <span className="ms-2 text-muted">{date}</span>
            </i>
        </div>
    </div>
);

const PieChartComponent = ({ HeadCount, male, female }) => {
    // ✅ Ensure `data` is an array
    const data = [
        { name: "Male", value: male, color: "#FFC107" }, // Yellow
        { name: "Female", value: female, color: "#4CAF50" }, // Green
        { name: "Total Head Count", value: HeadCount, color: "#FF5722" }, // Orange
    ];

    return (
        <PieChart width={380} height={420}>
            <Pie
                data={data} // ✅ Ensure `data` is an array here
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={120}
                label
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
            </Pie>
            <Tooltip />
            <Legend />
        </PieChart>
    );
};

const DepartmentChartComponent = ({ data1 }) => {
    // ✅ Ensure `data` is an array
    const data = [
        { name: "Admin", value: 2, color: "#FFC107" }
    ];
    data1 = data1 ? data1 : data;

    return (
        <PieChart width={380} height={420}>
            <Pie
                data={data1} // ✅ Ensure `data` is an array here
                dataKey="empCount"
                nameKey="departmentName"
                cx="50%"
                cy="50%"
                outerRadius={120}
                label
            >
                {data1.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
            </Pie>
            <Tooltip />
            <Legend />
        </PieChart>
    );
};

const EmployeeChart = (TotalEmployee, newJoining, left) => {
    const data = [
        { name: "Active", Count: TotalEmployee.TotalEmployee },
        { name: "New Joining", Count: TotalEmployee.newJoining },
        { name: "Left", Count: TotalEmployee.left },
    ];
    return (
        <div className="flex justify-center items-center">
            <h6 className="text-xl font-semibold">Employee Month Wise</h6>
            <BarChart width={250} height={300} data={data} >
                {/*<CartesianGrid strokeDasharray="3 3" />*/}
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Count" fill="#3366cc" />
            </BarChart>
        </div>
    );
};

const SalesChart = (Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec) => {
    const data = [
        { name: "Jan", CTC: Jan.Jan },
        { name: "Feb", CTC: Jan.Feb },
        { name: "Mar", CTC: Jan.Mar },
        { name: "Apr", CTC: Jan.Apr },
        { name: "May", CTC: Jan.May },
        { name: "Jun", CTC: Jan.Jun },
        { name: "Jul", CTC: Jan.Jul },
        { name: "Aug", CTC: Jan.Aug },
        { name: "Sep", CTC: Jan.Sep },
        { name: "Oct", CTC: Jan.Oct },
        { name: "Nov", CTC: Jan.Nov },
        { name: "Dec", CTC: Jan.Dec },
    ];
    return (
        <div className="flex flex-col items-center">
            <h6 className="text-xl font-semibold">Monthly CTC</h6>
            <BarChart width={250} height={300} data={data} margin={{ top: 10, right: 0, left: 25, bottom: 10 }}>
                {/*<CartesianGrid strokeDasharray="1 1" />*/}
                <XAxis dataKey="name" />
                <YAxis/>
                <Tooltip />
                <Legend />
                <Bar dataKey="CTC" fill="#3366cc" />
            </BarChart>
        </div>
    );
};


export default DashboardRight;